// @flow
import { SIMPLE } from "@localytics/redux-simple-api-middleware/lib/constants";
import * as Types from "./actionTypes";

type LoginArgs = { username: string, password: string, next: ?string };

export const login = ({ username, password, next }: LoginArgs) => ({
  [SIMPLE]: {
    endpoint: `auth/api/v1/login`,
    types: [
      Types.REQUEST_ACTION_TYPE,
      Types.SUCCESS_ACTION_TYPE,
      Types.FAILURE_ACTION_TYPE
    ],
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    },
    method: "POST",
    body: {
      username,
      ...(password ? { password } : null)
    },
    payload: {
      next,
      sentPass: !!password
    },
    context: {}
  }
});

export const reset = () => ({
  type: Types.RESET
});

export default login;
